/*
     This is utility function which extends zustand functionality
     With this function you can update state with callback and get access to current state when you updating the actual state.

    @Params: 
        - set<Set>: zustand set function
        - changingState<string>: state name which need to be changed 
        - payload<T | any>: new payload for updating state

*/

export const updateWithAccessToPreviousState = (
  set: any,
  changingState: string,
  payload: ((state: any) => any) | any
) => {
  if (typeof payload === 'function') {
    const callback = payload

    return set((state: { [x: string]: any }) => ({
      [changingState]: callback(state[changingState]),
    }))
  }

  return set(() => ({
    [changingState]: payload,
  }))
}
